import type { IFieldTemplate, IFieldTemplateDetail } from '../../../store';
import type { ISelectOption } from '../../../utils/types';

export const getResourceOptions = (fields: IFieldTemplate[]): ISelectOption[] => {
  const labelsByResource = new Map<string, string>();
  fields.forEach((field) => {
    if (!labelsByResource.has(field.resource)) {
      labelsByResource.set(field.resource, field.resource_label);
    }
  });
  return Array.from(labelsByResource, ([value, label]) => ({ value, label }));
};

export const getFieldOptions = (fields: IFieldTemplate[], resource: string): ISelectOption[] =>
  fields
    .filter((field) => field.resource === resource)
    .map((field) => ({ value: field.value, label: field.label }));

export const getSelectedIdentifier = (
  fields: IFieldTemplate[],
  resource: string,
  field: string,
): string =>
  fields.find((item) => item.resource === resource && item.value === field)?.identifier ?? '';

export const getIsTemplateReady = (
  selectedIdentifier: string,
  fieldTemplateLoading: boolean,
  fieldTemplate: IFieldTemplateDetail | null,
): boolean =>
  !!selectedIdentifier &&
  !fieldTemplateLoading &&
  fieldTemplate?.identifier === selectedIdentifier;
